module.exports = __webpack_public_path__ + "static/media/bat2.481eec89.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/bat2.png
// module id = 470
// module chunks = 0